/**
 * Pure helpers for distinguishing a resignation from a combat elimination.
 *
 * Both outcomes are recorded in `eliminated`; only resignations are also
 * recorded in `resigned`. The event fallback keeps older wire states usable.
 */

interface MaybeResignEvent {
  kind?: string
  player?: string
}

export interface PlayerStatusSource {
  eliminated?: readonly string[]
  resigned?: readonly string[]
  events?: readonly MaybeResignEvent[]
}

/** Return the slot IDs of players who left by resigning. */
export function resignedSlotIds(state: PlayerStatusSource | undefined): Set<string> {
  if (state?.resigned && state.resigned.length > 0) {
    return new Set(state.resigned)
  }

  const ids = new Set<string>()
  for (const event of state?.events ?? []) {
    if (event.kind === 'resign' && event.player) ids.add(event.player)
  }
  return ids
}

/** True when the given player left by resignation rather than combat. */
export function isPlayerResigned(
  state: PlayerStatusSource | undefined,
  playerId: string,
): boolean {
  return resignedSlotIds(state).has(playerId)
}
